import { render, staticRenderFns } from "./customerType.vue?vue&type=template&id=0a4e2b6d&"
import script from "./customerType.vue?vue&type=script&lang=js&"
export * from "./customerType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports